import { render } from "./ClientesMigracao.vue?vue&type=template&id=e9231290&scoped=true"
import script from "./ClientesMigracao.vue?vue&type=script&lang=js"
export * from "./ClientesMigracao.vue?vue&type=script&lang=js"

import "./ClientesMigracao.vue?vue&type=style&index=0&id=e9231290&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9231290"]])

export default __exports__